import { Widgets } from '@common/enums';
import { defaultWidgetParams, defaultWidgetPermission } from '@common/constants';

import type { LogoEntity } from '@sites/entity-core';
import { createLogo } from '@sites/entity-core';

import { type WebWidgetModel } from '@web/types';

import { LogoViewComponent } from '../components/logo-view/logo-view.component';
import { LogoControlComponent } from '../components/logo-control/logo-control.component';

// DEFAULT COMPONENT SETTINGS — sourced from the canonical entity factory in @sites/entity-core.
// The logo carries no translatable content; `styles` is a typed bag on the envelope
// (image/line/indent precedent), not the open JSS record.
//
// `data` is a factory so every inserted logo gets its own object — the widget factory passes a
// plain `data` value straight through to the new entity, and a shared reference would be one object
// behind every logo on the page.
const logoData = (): LogoEntity['data'] => createLogo().data;
// END DEFAULT SETTINGS

export const logoWidgetModel: WebWidgetModel = {
    componentView: LogoViewComponent,
    componentControl: LogoControlComponent,
    name: Widgets.LOGO,
    label: 'widget_logo_label',
    data: logoData,
    styles: createLogo().styles,
    permission: defaultWidgetPermission,
    params: { ...defaultWidgetParams, type: ['specific'] },
    signalForm: true,
};
